import { createFileRoute, Outlet } from '@tanstack/react-router';
import { AppLayout } from '@/app/layout/AppLayout';
import { PublicLayout } from '@/app/layout/PublicLayout';
import { SessionGate } from '@/modules/identity/public';

/**
 * Páginas abertas: funcionam com e sem login, na MESMA URL — um link de
 * evento compartilhado serve para quem já é usuário e para quem não é.
 *
 * Sem sessão: layout público (marca + Criar conta / Entrar).
 * Com sessão: o layout normal da plataforma, com menu e perfil.
 *
 * O que vai aqui não pode depender de dado que exija token.
 */
export const Route = createFileRoute('/_aberto')({
  component: function OpenLayout() {
    const { auth } = Route.useRouteContext();
    return auth.isAuthenticated ? (
      <SessionGate>
        <AppLayout>
          <Outlet />
        </AppLayout>
      </SessionGate>
    ) : (
      <PublicLayout>
        <Outlet />
      </PublicLayout>
    );
  },
});
